import { ComponentProps, ReactNode, useMemo } from 'react';

import CalendlyEmbed from './CalendlyEmbed';

type Provider = 'calendly';

const detectProvider = (url: string): Provider | null => {
  try {
    const { protocol, hostname } = new URL(url);
    if (protocol === 'https:' && (hostname === 'calendly.com' || hostname.endsWith('.calendly.com'))) {
      return 'calendly';
    }
  } catch {
    return null;
  }

  return null;
};

interface SchedulingWidgetProps extends Omit<ComponentProps<'div'>, 'children'> {
  calendarUrl: string;
  fallback?: ReactNode;
}

export default function SchedulingWidget({ calendarUrl, ...props }: SchedulingWidgetProps) {
  const provider = useMemo(() => detectProvider(calendarUrl), [calendarUrl]);

  switch (provider) {
    case 'calendly':
      return (
        <CalendlyEmbed
          url={calendarUrl}
          {...props}
        />
      );
    default:
      return null;
  }
}
